import React from "react";
import profileImage from "../assets/img/avatars/profileImage.jpg";
import { handleToggleContractors } from "actions/actions";
import { toast } from "react-toastify";
import BlockToggle from "views/admin/moqawelon/components/BlockToggle";
import DeleteUser from "views/admin/users/components/DeleteUser";
import "../styles/moqawelonColumn.css";
import ImageModal from "../components/imageModel/imageMode.jsx";
import { useState } from "react";
import { localizeSupplierTypes } from "utils/localization";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const SuppliersColumn = (refetch) => [
  {
    Header: "تحديد",
    id: "checkbox",
  },
  {
    Header: "الاسم",
    accessor: "name",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);
      return (
        <div className="flex min-w-[140px] items-center gap-3">
          <img
            src={
              row.original.photo
                ? `${BASE_URL}/${row.original?.photo}`
                : profileImage
            }
            alt={row.values.id}
            className="h-12 w-12 cursor-pointer rounded-lg object-cover"
            crossOrigin="anonymous"
            onClick={() => setIsModalOpen(true)}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.original.photo
                  ? `${BASE_URL}/${row.original?.photo}`
                  : profileImage
              }
              onClose={() => setIsModalOpen(false)}
            />
          )}
          <span className="font-medium">{row.original.name || "—"}</span>
        </div>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    accessor: "phoneNumber",
    Cell: ({ row }) => (
      <a
        className="text-blue-500 hover:underline"
        href={`tel:${row.original.phoneNumber}`}
      >
        {row.original.phoneNumber}
      </a>
    ),
  },
  {
    Header: "الرقم الضريبي",
    accessor: "supplierInfo.taxNumber",
    Cell: ({ row }) => row.original?.supplierInfo?.taxNumber || "—",
  },
  {
    Header: "السجل التجاري",
    accessor: "supplierInfo.commercialRegister",
    Cell: ({ row }) => row.original?.supplierInfo?.commercialRegister || "—",
  },
  {
    Header: "ملف التعريف",
    accessor: "supplierInfo.profilePdf",
    Cell: ({ row }) => {
      const pdf = row.original?.supplierInfo?.profilePdf;
      if (!pdf) return "—";
      return (
        <a
          className="text-blue-500 hover:underline"
          href={`${BASE_URL}/${pdf}`}
          target="_blank"
          rel="noreferrer"
        >
          عرض الملف
        </a>
      );
    },
  },
  {
    Header: "أنواع التوريد",
    accessor: "supplierInfo.types",
    Cell: ({ row }) => localizeSupplierTypes(row.original?.supplierInfo?.types),
  },
  {
    Header: "المواقع",
    accessor: "supplierInfo.locations",
    Cell: ({ row }) => {
      const locs = row.original?.supplierInfo?.locations || [];
      if (!locs.length) return "—";
      return (
        <ul className="text-xs">
          {locs.map((l, i) => (
            <li key={i}>
              {l.region} - {l.city}
              {l.district ? ` - ${l.district}` : ""}
            </li>
          ))}
        </ul>
      );
    },
  },
  {
    Header: "الحالة",
    accessor: "active",
    Cell: ({ row }) => (
      <span
        className={`rounded-full px-2 py-1 text-xs ${
          row.values.active
            ? "bg-green-500 text-white"
            : "bg-red-500 text-white"
        }`}
      >
        {row.values.active ? "مفعل" : "غير مفعل"}
      </span>
    ),
  },
  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => (
      <div className="flex flex-col items-start gap-2">
        {row.original.active ? (
          <BlockToggle
            id={row.original.id}
            refetch={refetch}
            name={row.original.name}
          />
        ) : (
          <button
            className="rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            onClick={() =>
              handleToggleContractors(row.original.id, "active").then((res) => {
                if (res.error) toast.error(res.error);
                else {
                  toast.success(res.success);
                  refetch();
                }
              })
            }
          >
            تفعيل
          </button>
        )}
        <DeleteUser id={row.original.id} refetch={refetch} />
      </div>
    ),
  },
];

export default SuppliersColumn;
